<div *ngIf="globalSpinnerService.state | async as state"
     class="global-spinner flex-column justify-content-center align-items-center"
     [class.d-flex]="state.isShown">
  <div class="global-spinner-content d-flex flex-column justify-content-center align-items-center">
    <mat-spinner color="accent"></mat-spinner>
    <div class="mt-4 text-large">{{ state.loadingText | translate }}</div>
    <div *ngIf="state.loadingSubtext">{{ state.loadingSubtext | translate }}</div>
  </div>
</div>
